import { TableScreen } from './tables';
import { QRCodeScreen } from './QRCode';
import { TemplateScreen } from './Template';

export { TableScreen, QRCodeScreen, TemplateScreen };
